import { debounce } from "lodash";

export const debouncedFunction = debounce((value, callback) => {
  callback(value);
}, 300);

